module.exports = require("./zh-Hans-HK.js");